import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Building2, Users, Wallet, Activity } from "lucide-react";
import { toast } from "sonner";

function formatEUR(v) {
  return Number(v || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
}

const STATUS_LABEL = {
  trialing: "In prova",
  active: "Attive",
  past_due: "Scadute",
  canceled: "Sospese",
  expired: "Scadute",
  pending: "In attesa",
};

export default function MasterDashboard() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/master/dashboard").then(r => setS(r.data)).catch(e => toast.error(formatApiError(e)));
  }, []);

  if (!s) return <div className="text-slate-400 text-sm">Caricamento…</div>;

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-wider text-amber-400 font-semibold">Panoramica piattaforma</div>
        <h1 className="font-heading text-3xl font-bold">Master Console</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Card className="p-5 bg-slate-900 border-slate-800">
          <Building2 className="w-5 h-5 text-amber-400 mb-2" />
          <div className="font-heading text-2xl font-bold font-mono-num" data-testid="stat-agencies">{s.total_agencies}</div>
          <div className="text-xs text-slate-400 mt-1">Agenzie totali</div>
        </Card>
        <Card className="p-5 bg-slate-900 border-slate-800">
          <Users className="w-5 h-5 text-amber-400 mb-2" />
          <div className="font-heading text-2xl font-bold font-mono-num" data-testid="stat-users">{s.total_users}</div>
          <div className="text-xs text-slate-400 mt-1">Utenti attivi</div>
        </Card>
        <Card className="p-5 bg-emerald-900/30 border-emerald-700/50">
          <Wallet className="w-5 h-5 text-emerald-400 mb-2" />
          <div className="font-heading text-2xl font-bold font-mono-num text-emerald-400" data-testid="stat-mrr-net">{formatEUR(s.mrr_net)}</div>
          <div className="text-xs text-emerald-300/80 mt-1">MRR netto</div>
        </Card>
        <Card className="p-5 bg-emerald-900/30 border-emerald-700/50">
          <Wallet className="w-5 h-5 text-emerald-400 mb-2" />
          <div className="font-heading text-2xl font-bold font-mono-num text-emerald-400" data-testid="stat-mrr-vat">{formatEUR(s.mrr_with_vat)}</div>
          <div className="text-xs text-emerald-300/80 mt-1">MRR (comprensivo di oneri di legge)</div>
        </Card>
      </div>

      <Card className="p-5 bg-slate-900 border-slate-800">
        <div className="flex items-center gap-2 mb-3">
          <Activity className="w-4 h-4 text-amber-400" />
          <h2 className="font-heading font-semibold">Distribuzione per stato</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {Object.entries(s.by_status || {}).map(([k, v]) => (
            <div key={k} className="rounded-md bg-slate-800 p-3 border border-slate-700">
              <div className="text-[10px] uppercase tracking-wider text-slate-400 font-semibold">{STATUS_LABEL[k] || k}</div>
              <div className="font-heading text-xl font-bold font-mono-num mt-1">{v}</div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
